import { formatDate, localize } from 'mixins/helpers';
import dayjs from 'dayjs';

export const columns = (translations: Record<string, string>) => {
    return [
        {
            title: localize('find-taxpayer-service-registration-date', translations),
            dataIndex: 'beginDate',
            key: 'beginDate',
            render: (beginDate) => formatDate(beginDate),
        },
        {
            title: localize('find-taxpayer-service-de-registration-date', translations),
            dataIndex: 'endDate',
            key: 'endDate',
            render: (endDate) => formatDate(endDate),
        },
        {
            title: localize('find-taxpayer-service-de-registration-reasons', translations),
            dataIndex: 'reason',
            key: 'reason',
            render: (reason) => reason || '-',
        },
        {
            title: localize('find-taxpayer-service-activity-suspension-period', translations),
            dataIndex: 'suspensionPeriod',
            key: 'suspensionPeriod',
            render: (suspensionPeriod) => suspensionPeriod || '-',
        },
    ];
};

export const TAXPAYER_TYPE_PREFIX = 'find-taxpayer-service-taxpayer-type';

export const RESULTS_LIMIT = 150;

export const IDENTIFIER_TYPE_PREFIX = 'find-taxpayer-service';
export const IDENTIFIER_TYPE_MAP = {
    FL: 'iin',
    IP: 'iin-bin',
    IPS: 'iin-bin',
    UL: 'bin',
    UL_NR: 'bin',
    FL_NR: 'iin',
    LZCHP: 'iin',
};
